import { createFileRoute } from "@tanstack/react-router";
import AdminTrainingLocalNewPage from "@/pages/admin/lms/trainings-local/new";
import { useLmsPermissions } from "@/pages/admin/lms";

export const Route = createFileRoute("/app/admin/lms/trainings-local/new")({
  component: RouteComponent,
});

function RouteComponent() {
  const { userCanEditAllMaterials, userCanViewAllMaterials } = useLmsPermissions();

  return (
    <AdminTrainingLocalNewPage
      userCanEditAllMaterials={userCanEditAllMaterials}
      userCanViewAllMaterials={userCanViewAllMaterials}
    />
  );
}
